import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { CurrentSubscriptionResponseDto } from "libs/cellera-sdk";

import { practicePaymentApi } from "../apis";

/**
 * Hook to fetch current subscription and billing status
 * Uses the new /practice-payment/subscription endpoint
 * Returns subscription details including billing status
 */
export const usePaymentStatus = (isPracticeOwner: boolean) => {
  return useQuery<CurrentSubscriptionResponseDto>({
    queryKey: ["payment-status", "subscription"],
    queryFn: async () => {
      try {
        const response = await practicePaymentApi.getCurrentSubscription();
        return response;
      } catch (error) {
        console.error("Failed to fetch subscription status:", error);
        throw error;
      }
    },
    retry: 1,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    enabled: isPracticeOwner,
    placeholderData: keepPreviousData,
  });
};
